import ContentLoader from "react-content-loader";
import styles from "./style.module.scss";

export default function WidgetSkeleton() {
    return (
        <div className={styles["skeleton-container"]}>
            <ContentLoader
                speed={2}
                width="100%"
                height="100%"
                viewBox="0 0 400 600"
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
                className={styles["skeleton-loader"]}
            >
                {/* Title skeleton */}
                <rect x="0" y="50" rx="4" ry="4" width="300" height="28" />

                {/* Description skeleton */}
                <rect x="0" y="100" rx="4" ry="4" width="380" height="16" />
                <rect x="0" y="125" rx="4" ry="4" width="360" height="16" />
                <rect x="0" y="150" rx="4" ry="4" width="320" height="16" />

                {/* Label skeleton */}
                <rect x="0" y="190" rx="4" ry="4" width="100" height="14" />

                {/* First input field skeleton */}
                <rect x="0" y="210" rx="6" ry="6" width="400" height="50" />

                {/* Second label skeleton */}
                <rect x="0" y="280" rx="4" ry="4" width="120" height="14" />

                {/* Second input field skeleton */}
                <rect x="0" y="300" rx="6" ry="6" width="400" height="50" />

                {/* Third label skeleton */}
                <rect x="0" y="370" rx="4" ry="4" width="110" height="14" />

                {/* Third input field skeleton */}
                <rect x="0" y="390" rx="6" ry="6" width="400" height="50" />

                {/* Submit button skeleton */}
                <rect x="0" y="460" rx="6" ry="6" width="400" height="60" />

                {/* Footer text skeleton */}
                <rect x="0" y="540" rx="4" ry="4" width="350" height="12" />
                <rect x="0" y="560" rx="4" ry="4" width="300" height="12" />
            </ContentLoader>
        </div>
    );
}
